import React from "react";

const EditClientPaymentsPage = (paymentRequestId) => {
    return (
        <>
            <h1>This is EditClientPayments Page</h1>
        </>
    );
};

export default EditClientPaymentsPage;
